module.exports = __webpack_public_path__ + "static/media/igi_auction_sealed_bid.960d9ce6.png";